import { render } from "./TvmNewVehicle.vue?vue&type=template&id=2bafd389&scoped=true"
import script from "./TvmNewVehicle.vue?vue&type=script&lang=js"
export * from "./TvmNewVehicle.vue?vue&type=script&lang=js"

import "./TvmNewVehicle.vue?vue&type=style&index=0&id=2bafd389&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bafd389"]])

export default __exports__